// GraphQL error codes surfaced via `extensions: { code: ... }` on
// `GraphQL::ExecutionError`. Shared so the raise site (Rails) and the detect
// sites (Apollo error link, mutation catch helper) agree on the wire value.

export const READ_ONLY_ADMIN_WRITE_DENIED_CODE = 'READ_ONLY_ADMIN_WRITE_DENIED';
export const ESTIMATED_AUM_REQUIRED_CODE = 'ESTIMATED_AUM_REQUIRED';
export const PROFESSIONAL_RELATIONSHIP_ACCESS_DENIED_CODE = 'PROFESSIONAL_RELATIONSHIP_ACCESS_DENIED';
export const PROFESSIONAL_CONTACT_ACCESS_DENIED_CODE = 'PROFESSIONAL_CONTACT_ACCESS_DENIED';

// The occurrence-scoped mutations (4C1T-623). Each message is written to be shown to the
// advisor as-is, so the client surfaces the server's copy rather than a generic fallback.
// Raised from `ServiceCatalog::OccurrenceLookup::STALE_CODE` / `RESOLVED_CODE` and
// `Mutations::ServiceCatalog::ResendServiceOccurrenceReminder#refusal`.
export const OCCURRENCE_STALE_CODE = 'OCCURRENCE_STALE';
export const OCCURRENCE_ALREADY_RESOLVED_CODE = 'OCCURRENCE_ALREADY_RESOLVED';
export const OCCURRENCE_NOT_SENDABLE_CODE = 'OCCURRENCE_NOT_SENDABLE';
export const OCCURRENCE_NOT_RESCHEDULABLE_CODE = 'OCCURRENCE_NOT_RESCHEDULABLE';
export const OCCURRENCE_DATE_TAKEN_CODE = 'OCCURRENCE_DATE_TAKEN';
// Partial success, not a failure: the occurrence HAS moved to its new date and the row is marked
// failed; only the invite did not go out. A client showing the old date after this is lying about
// committed state, so it must refetch as well as report (`reschedule_occurrence.rb:238-241`).
export const OCCURRENCE_MOVED_BUT_SEND_FAILED_CODE = 'OCCURRENCE_MOVED_BUT_SEND_FAILED';
